import { productCategoryAddPath, productCategoryDeletePath, productCategoryFindAllPageablePath, productCategoryFindAllPath, productCategoryFindByIdPath, productCategoryUpdatePath } from "../constants/apiEndpoints";
import { ModalForAddOrUpdateProductCategory } from "../enums/ProductCategoryEnums";
import {
    handleServerErrorMessage,
    handleServerSuccessMessage
} from "../utils";
import apiService from "../utils/apiService";
import {
    ADD_PRODUCT_CATEGORY,
    ADD_PRODUCT_CATEGORY_ERROR,
    ADD_PRODUCT_CATEGORY_START,
    CLEAR_ERROR_PRODUCT_CATEGORY,
    DELETE_PRODUCT_CATEGORY,
    DELETE_PRODUCT_CATEGORY_ERROR,
    DELETE_PRODUCT_CATEGORY_START,
    GET_PRODUCT_CATEGORY,
    GET_PRODUCT_CATEGORY_ERROR,
    GET_PRODUCT_CATEGORY_LIST,
    GET_PRODUCT_CATEGORY_LIST_ERROR,
    GET_PRODUCT_CATEGORY_LIST_PAGEABLE,
    GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR,
    GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START,
    GET_PRODUCT_CATEGORY_LIST_START,
    GET_PRODUCT_CATEGORY_START,
    UPDATE_PRODUCT_CATEGORY,
    UPDATE_PRODUCT_CATEGORY_ERROR,
    UPDATE_PRODUCT_CATEGORY_START
} from "./types"


const clearError = () => {
    return {
        type: CLEAR_ERROR_PRODUCT_CATEGORY,
    };
};
 


//ADD
const addProductCategoryStart = () => {
    return {
        type: ADD_PRODUCT_CATEGORY_START,
    };
};
const addProductCategorySuccessfully = (data) => {
    return {
        type: ADD_PRODUCT_CATEGORY,
        payload: data,
    };
};
const addProductCategoryUnsuccessfully = (err) => {
    return {
        type: ADD_PRODUCT_CATEGORY_ERROR,
        payload: err,
    };
};

//UPDATE
const updateProductCategoryStart = () => {
    return {
        type: UPDATE_PRODUCT_CATEGORY_START,
    };
};

const updateProductCategorySuccessfully = (data) => {
    return {
        type: UPDATE_PRODUCT_CATEGORY,
        payload: data,
    };
};

const updateProductCategoryUnsuccessfully = (err) => {
    return {
        type: UPDATE_PRODUCT_CATEGORY_ERROR,
        payload: err,
    };
};

//GET 

const getProductCategoryStart = () => {
    return {
        type: GET_PRODUCT_CATEGORY_START,
    };
};

const getProductCategorySuccessfully = (data) => {
    return {
        type: GET_PRODUCT_CATEGORY,
        payload: data,
    };
};

const getProductCategoryUnsuccessfully = (err) => {
    return {
        type: GET_PRODUCT_CATEGORY_ERROR,
        payload: err,
    };
};

//GET LIST
const getProductCategoryListStart = () => {
    return {
        type: GET_PRODUCT_CATEGORY_LIST_START,
    };
};

const getProductCategoryListSuccsessfully = (data) => {
    return {
        type: GET_PRODUCT_CATEGORY_LIST,
        payload: data,
    };
};

const getProductCategoryListUnsuccessfully = (err) => {
    return {
        type: GET_PRODUCT_CATEGORY_LIST_ERROR,
        payload: err,
    };
};

//DELETE

const deleteProductCategoryStart = () => {
    return {
        type: DELETE_PRODUCT_CATEGORY_START,
    };
};

const deleteProductCategorySuccessfully = (data) => {
    return {
        type: DELETE_PRODUCT_CATEGORY,
        payload: data,
    };
};

const deleteProductCategoryUnsuccessfully = (err) => {
    return {
        type: DELETE_PRODUCT_CATEGORY_ERROR,
        payload: err,
    };
};


//PAGEABLE
const getProductCategoryPageableListStart = () => {
  return {
    type: GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START,
  };
};

const getProductCategoryPageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_PRODUCT_CATEGORY_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getProductCategoryListPageableUnsuccessfully = (err) => {
  return {
    type: GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};


//ADD
export const createProductCategory = (productCategory, callback) => {
    return (dispatch) => {
        dispatch(addProductCategoryStart());
        return apiService
            .post(productCategoryAddPath(), productCategory)
            .then((response) => {
                dispatch(addProductCategorySuccessfully(response.data));
                handleServerSuccessMessage(
                    ModalForAddOrUpdateProductCategory.saveSuccessMessage,
                    productCategory);
                callback();
            })
            .catch((err) => {
                dispatch(addProductCategoryUnsuccessfully(err.response.data));
                handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
            });
    };
};


//UPDATE
export const updateProductCategory = (productCategory, callback) => {
    return (dispatch) => {
        dispatch(updateProductCategoryStart());
        return apiService
            .put(productCategoryUpdatePath(), productCategory)
            .then((response) => {
                dispatch(updateProductCategorySuccessfully(response.data));
                handleServerSuccessMessage(
                    ModalForAddOrUpdateProductCategory.updateSuccessMessage,
                    productCategory);
                callback();
            })
            .chatch((err) => {
                dispatch(updateProductCategoryUnsuccessfully(err.response.data));
                handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
            });
    };
};


//FIND BY ID

export const findProductCategoryById = (id) => {
    return (dispatch) => {
        dispatch(getProductCategoryStart());
        return apiService
            .get(productCategoryFindByIdPath(id))
            .then((response) => {
                dispatch(getProductCategorySuccessfully(response.data))
            })
            .catch((err) => {
                dispatch(getProductCategoryUnsuccessfully(err));
            });
    };
};


//FIND ALL

export const findAllProductCategorys = () => {
    return (dispatch) => {
        dispatch(getProductCategoryListStart());
        return apiService
            .get(productCategoryFindAllPath())
            .then((response) => {
                dispatch(getProductCategoryListSuccsessfully(response.data));
            })
            .catch((err) => {
                dispatch(getProductCategoryListUnsuccessfully(err));
            });
    };
};


//DELETE

export const deleteProductCategory = (id) => {
    return (dispatch) => {
        dispatch(deleteProductCategoryStart());
        return apiService
            .delete(productCategoryDeletePath(id))
            .then(() => {
                dispatch(deleteProductCategorySuccessfully(id));
                handleServerSuccessMessage(ModalForAddOrUpdateProductCategory.deleteSuccessMessage, { id });
            })
            .catch((err) => {
                dispatch(deleteProductCategoryUnsuccessfully(err.response.data));
                handleServerErrorMessage(
                    err?.respoonse?.status === 404
                        ? ServerMessagesEnums.deleteErrorMessage404
                        : err?.response?.data
                );
            });
    };
};


export const deleteErrorProductCategory = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};


//FIND ALL PAGEABLE
export const findAllProductCategorysPageable = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getProductCategoryPageableListStart);
    return apiService
      .get(productCategoryFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getProductCategoryPageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getProductCategoryListPageableUnsuccessfully(err));
      });
  };
};